import {
  addItemToTransaction,
  addItemToTransactionByBarcode,
  cancelTransaction,
  getPrintData, getPrinterData,
  getTransactionDetail, openCashTray,
  postTransaction,
  printReceipt,
  removeTransactionItem,
  updateTransactionItemQuantity,
} from '../../../../../../services/pos/transactions';
import actionTypes from '../constants/actionTypes';
import { addErrorMessage, addSuccessMessage } from '../../../../../../store/actions/message';
import { FormattedMessage } from 'react-intl';
import { resolveTransactionErrorCode } from '../../../../../../utils/helpers';

export const getReceipt = (id) => async (dispatch) => {
  const { RECEIPT_FETCH, RECEIPT_SUCCESS, RECEIPT_ERROR } = actionTypes;

  dispatch({ type: RECEIPT_FETCH });
  try {
    const payload = await getTransactionDetail(id);
    const transaction = payload?.data?.transaction;
    dispatch({ type: RECEIPT_SUCCESS, payload: transaction });
  } catch (error) {
    const errorResponse = error.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
    dispatch({ type: RECEIPT_ERROR, error: errorResponse });
  }
};

export const addItemToTransactionAction = (transactionId, itemId, quantity) => async (dispatch, getState) => {
  if(transactionId === 'new'){
    if(getState()?.receipt?.lines?.metadata?.lineFetching){
      return;
    }
  }

  const { RECEIPT_LINE_ADD_FETCH, RECEIPT_LINE_ADD_SUCCESS, RECEIPT_LINE_ADD_ERROR } = actionTypes;
  dispatch({ type: RECEIPT_LINE_ADD_FETCH });
  try {
    const newItem = await addItemToTransaction(transactionId, itemId, quantity);
    dispatch({ type: RECEIPT_LINE_ADD_SUCCESS, payload: newItem });
  } catch (error) {
    const errorResponse = error.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
    dispatch({ type: RECEIPT_LINE_ADD_ERROR, error: errorResponse });
  }
};

export const addItemToTransactionByBarcodeAction = (barcode, transactionId, quantity) => async (dispatch) => {
  const { RECEIPT_LINE_ADD_FETCH, RECEIPT_LINE_ADD_SUCCESS, RECEIPT_LINE_ADD_ERROR } = actionTypes;
  dispatch({ type: RECEIPT_LINE_ADD_FETCH });
  try {
    const newItem = await addItemToTransactionByBarcode(barcode, transactionId, quantity);
    dispatch({ type: RECEIPT_LINE_ADD_SUCCESS, payload: newItem });
  } catch (error) {
    const errorResponse = error.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
    dispatch({ type: RECEIPT_LINE_ADD_ERROR, error: errorResponse });
  }
};

export const updateTransactionItemQuantityAction = (transactionId, lineId, quantity) => async (dispatch) => {
  const { RECEIPT_LINE_EDIT_FETCH, RECEIPT_LINE_EDIT_SUCCESS, RECEIPT_LINE_EDIT_ERROR } = actionTypes;

  dispatch({ type: RECEIPT_LINE_EDIT_FETCH, payload: { data: { ID: lineId } } });
  try {
    const updatedItem = await updateTransactionItemQuantity(transactionId, lineId, quantity);
    dispatch({ type: RECEIPT_LINE_EDIT_SUCCESS, payload: updatedItem });
  } catch (error) {
    const errorResponse = error.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
    dispatch({ type: RECEIPT_LINE_EDIT_ERROR, error: errorResponse });
  }
};

export const removeTransactionItemAction = (transactionId, lineId) => async (dispatch) => {
  const { RECEIPT_LINE_REMOVE_FETCH, RECEIPT_LINE_REMOVE_SUCCESS, RECEIPT_LINE_REMOVE_ERROR } = actionTypes;

  dispatch({ type: RECEIPT_LINE_REMOVE_FETCH, payload: { lineId } });
  try {
    await removeTransactionItem(transactionId, lineId);
    dispatch({ type: RECEIPT_LINE_REMOVE_SUCCESS, payload: { lineId } });
  } catch (error) {
    const errorResponse = error.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
    dispatch({ type: RECEIPT_LINE_REMOVE_ERROR, error: errorResponse });
  }
};

export const resetState = () => async (dispatch) => {
  const { RECEIPT_RESET } = actionTypes;
  dispatch({ type: RECEIPT_RESET });
};

export const postTransactionAction = (id, paymentType, paymentAmount) => async (dispatch) => {
  const { RECEIPT_POSTING_FETCH, RECEIPT_POSTING_SUCCESS, RECEIPT_POSTING_ERROR } = actionTypes;
  dispatch({ type: RECEIPT_POSTING_FETCH });
  try {
    const output = await postTransaction(id, paymentType, paymentAmount);
    dispatch({ type: RECEIPT_POSTING_SUCCESS });
    dispatch(addSuccessMessage(<FormattedMessage id={'transaction.successfullyPosted'}
                                                 values={{ transactionNo: output?.data?.documentNumber }} />));
  } catch (error) {
    const errorResponse = error.response.data;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.error)));
    dispatch({ type: RECEIPT_POSTING_ERROR, error: { ...errorResponse } });
  }
};

export const cancelTransactionAction = (id) => async (dispatch) => {
  const { RECEIPT_CANCELLING_FETCH, RECEIPT_CANCELLING_SUCCESS, RECEIPT_CANCELLING_ERROR } = actionTypes;
  dispatch({ type: RECEIPT_CANCELLING_FETCH });
  try {
    await cancelTransaction(id);
    dispatch(addSuccessMessage(<FormattedMessage id={'transaction.successfullyCancelled'} />));
    dispatch({ type: RECEIPT_CANCELLING_SUCCESS });
  } catch (error) {
    const errorResponse = error.response.data;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.error)));
    dispatch({ type: RECEIPT_CANCELLING_ERROR, error: { ...errorResponse } });
  }
};

export const getPrintDataAction = (id) => async (dispatch) => {
  const { RECEIPT_PRINT_DATA_FETCH, RECEIPT_PRINT_DATA_SUCCESS, RECEIPT_PRINT_DATA_ERROR } = actionTypes;
  dispatch({ type: RECEIPT_PRINT_DATA_FETCH });
  try {
    const response = await getPrintData(id);
    const { printerIP, printerPort, printServerAddress, printServerToken, data } = response.data;
    try {
      await printReceipt(printServerAddress, printServerToken, printerIP, printerPort, data);
    } catch (e) {
      console.log('Print Error', e);
    }
    dispatch({ type: RECEIPT_PRINT_DATA_SUCCESS });
  } catch (error) {
    const errorResponse = error.response.data;
    dispatch({ type: RECEIPT_PRINT_DATA_ERROR, error: { ...errorResponse } });
  }
};

export const openCashTrayAction = () => async (dispatch) => {
  const { PRINTER_DATA_FETCH, PRINTER_DATA_SUCCESS, PRINTER_DATA_ERROR } = actionTypes;
  dispatch({ type: PRINTER_DATA_FETCH });
  try {
    const response = await getPrinterData();
    const { printerIP, printerPort, printServerAddress, printServerToken } = response.data;
    try {
      await openCashTray(printServerAddress, printServerToken, printerIP, printerPort);
    } catch (e) {
      console.log('Cash Tray Opening Error', e);
    }
    dispatch({ type: PRINTER_DATA_SUCCESS });
  } catch (error) {
    const errorResponse = error.response.data;
    dispatch({ type: PRINTER_DATA_ERROR, error: { ...errorResponse } });
  }
};


